import styled from '@emotion/styled';
import React from 'react';
import Lottie from 'react-lottie-player';

import { ReactComponent as HappyWomanIllustration } from 'src/public/ds/illustrations/marginalia-happy-woman.svg';
import { ReactComponent as VirtualRealityIllustration } from 'src/public/ds/illustrations/marginalia-virtual-reality.svg';
import { ReactComponent as QuestionWomanIllustration } from 'src/public/ds/illustrations/illu-question-square.svg';
import { ReactComponent as ConstructionIllustration } from 'src/public/ds/illustrations/marginalia-page-under-construction.svg';
import confettiAnimation from 'src/public/animations/colorful_confetti.json';

export enum IllustrationType {
    APPROVED = 'APPROVED',
    INELIGIBLE = 'INELIGIBLE',
    INACTIVE = 'INACTIVE',
    ERROR = 'ERROR',
}
interface IllustrationGeneratorProps {
    illustrationType: IllustrationType;
}

const ConfettiAnimation = styled(Lottie)({
    width: 400,
    maxHeight: 215,
    opacity: 0.7,
    position: 'absolute',
    overflow: 'hidden',
});

export const IllustrationGenerator: React.FC<IllustrationGeneratorProps> = ({
    illustrationType,
}) => {
    let illustrationMap: Map<IllustrationType, React.ReactNode> = new Map([
        [
            IllustrationType.APPROVED,
            <>
                <ConfettiAnimation animationData={confettiAnimation} speed={0.6} play loop />
                <HappyWomanIllustration />
            </>,
        ],
        [IllustrationType.INELIGIBLE, <VirtualRealityIllustration key={1} />],
        [IllustrationType.INACTIVE, <QuestionWomanIllustration key={2} />],
        [IllustrationType.ERROR, <ConstructionIllustration key={3} />],
    ]);

    if (!illustrationMap.has(illustrationType)) {
        throw Error(`illustrationType of ${illustrationType} does not exist in illustrationMap`);
    }

    const illustration: React.ReactNode = illustrationMap.get(illustrationType);
    return <>{illustration}</>;
};
